import React, { useContext, useEffect } from "react";
import SalesStatisticOne from "./child/SalesStatisticOne";
import TotalSubscriberOne from "./child/TotalSubscriberOne";
import UsersOverviewOne from "./child/UsersOverviewOne";
import LatestRegisteredOne from "./child/LatestRegisteredOne";
import TopPerformerOne from "./child/TopPerformerOne";
import TopCountries from "./child/TopCountries";
import GeneratedContent from "./child/GeneratedContent";
import UnitCountOne from "./child/UnitCountOne";
import DonutChart from "./child/DonutChart";
import BasicPieChart from "./child/BasicPieChart";
import RecentOrdersOne from "./child/RecentOrdersOne";
import TableDataLayer from "./TableDataLayer";
import MainDashboardChartComponent from "./child/1_MainDashboardChartComponent";
import { StoreContext } from "../store/Store";
import DashboardLineChart from "../charts/DashboardLineChart";
import DashboardBarChart from "../charts/DashboardBarChart";
import DashboardPieChart from "../charts/DashboardPieChart";
import StripedRows from "./child/StripedRows";
import Loader from "./Loader/Loader";

const DashBoardLayerOne = () => {
  const { getOverAllKPI, overAllKPI, getTableData, tableData, loading } =
    useContext(StoreContext);

  console.log(tableData);

  console.log(overAllKPI);

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getOverAllKPI(configid);
  }, []);

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getTableData(configid);
  }, []);

  // console.log(overAllKPI);
  return (
    <>
      {/* UnitCountOne */}
      <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
        {overAllKPI.map((item, index) =>
          item.chart_type === "KPI Chart" ? (
            <UnitCountOne data={item} idx={index} />
          ) : null
        )}
      </div>

      <section className="row gy-3 gx-3 mt-1">
        <MainDashboardChartComponent />
      </section>

      <section className="row gy-3 gx-3 mt-1">
        {tableData
          .filter((table) => table.chart_type === "Table")
          .slice(0, 1)
          .map((table, index) => (
            <RecentOrdersOne key={index} table={table} />
          ))}
      </section>

      <section className="row gy-3 gx-3 mt-1">
        {/* SalesStatisticOne */}
        {/* <SalesStatisticOne /> */}
        {overAllKPI.map((item, index) =>
          item.chart_type === "Line Chart" ? (
            <div className="col-12 col-md-4">
              <DashboardLineChart metricData={item} />
            </div>
          ) : null
        )}

        {/* TotalSubscriberOne */}
        {/* <TotalSubscriberOne /> */}
        {overAllKPI.map((item, index) =>
          item.chart_type === "Bar Chart" ? (
            <div className="col-12 col-md-4">
              <DashboardBarChart metricData={item} />
            </div>
          ) : null
        )}

        {/* UsersOverviewOne */}
        {/* <UsersOverviewOne /> */}
        {overAllKPI.map((item, index) =>
          item.chart_type === "Pie Chart" ? (
            <div className="col-12 col-md-4">
              <DashboardPieChart metricData={item} />
            </div>
          ) : null
        )}

        {/* TopCountries */}
        {/* <DonutChart /> */}
        {/* GeneratedContent */}
        {/* <GeneratedContent /> */}

        {/* LatestRegisteredOne */}
        {/* <RecentOrdersOne /> */}
        {/* <TableDataLayer/> */}

        {/* TopPerformerOne */}
        {/* <BasicPieChart /> */}
      </section>

      <section className="row gy-3 gx-3 mt-1">
        {tableData
          .filter((table) => table.chart_type === "Table")
          .slice(1, 3)
          .map((table, index) => (
            <div className="col-6" key={index}>
              <RecentOrdersOne table={table} />
            </div>
          ))}
      </section>
      <section className="row gy-3 gx-3 mt-1">
        {tableData
          .filter((table) => table.chart_type === "Table")
          .slice(3, 5)
          .map((table, index) => (
            <div className="col-12" key={index}>
              <RecentOrdersOne table={table} />
            </div>
          ))}
      </section>
    </>
  );
};

export default DashBoardLayerOne;
